module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fzBr62/images/9781439649411.jpg?1684514748931",
      "alt": "This image is the cover for the book Blue Ridge Scenic Railway, Images of Rail"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blue Ridge Scenic Railway, Images of Rail\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Having whistled its first \"all aboard\" in 1988, the Blue Ridge Scenic Railway now rambles alongside the Toccoa's clear waters, treating 50,000-plus sightseers annually to verdant mountain scenery. This former Cherokee land's pioneers carved homesteads from rough terrain, doggedly hauling goods via mule wagon. The discovery of rich copper veins in nearby Polk County, Tennessee, attracted an influx of settlers, but before they could enjoy an Industrial Age boom including rail for faster freight movement, they would endure route changes, bankruptcies, and land-rights issues. As Fannin, Polk, and surrounding counties neared the 20th century, the long-anticipated railroad arrived, and with it prosperity. This is a photographic history of the copper miners, shop owners, homesteaders, and railroad workers who made these mountains their homes, often for many proud generations.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melissa Beck\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Melissa Beck is a published fiction author whose many interests have led her at various times to show dogs, learn improv comedy, join a wool-hooking group, and run a busy needlework repair business. Born in Oak Ridge in the East Tennessee Valley, she regularly visited her grandparents in the Smokies. Melissa says the hills are in her blood, and she hopes to retire soon to her cabin in Fannin County, Georgia.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0